export const INCREMENT_REQUESTED = 'auth/INCREMENT_REQUESTED'
export const INCREMENT = 'auth/INCREMENT'
export const DECREMENT_REQUESTED = 'auth/DECREMENT_REQUESTED'
export const DECREMENT = 'auth/DECREMENT'

export const LOGIN_REQUESTED = 'auth/LOGIN_REQUESTED'
export const LOGIN_SUCCEED = 'auth/LOGIN_SUCCEED'
export const LOGIN_FAIL = 'auth/LOGIN_FAIL'

export const LOGOUT = 'auth/LOGOUT'



// WEBPACK FOOTER //
// ./src/redux/auth/actionTypes.js